/**
 * Transport und Container - 1:1-Portierung aus `index.html` (Stand 2026-08-08).
 *
 * Beide Konstanten beschreiben den Weg der Ware vom Hersteller bis ins ABSINA-Lager: die Stufen des
 * Zeitstrahls und die Containergroessen, mit denen das Volumen gerechnet wird.
 *
 * Werte woertlich uebernommen, ergaenzt wurden ausschliesslich Typen.
 */

export interface ShipStage {
  id: string;
  label: string;
}

/**
 * Transport-Stufen für den Zeitstrahl (Buchung → ABSINA) - index.html:4522-4530, Kommentar
 * woertlich uebernommen. Die Reihenfolge IST der Zeitstrahl; sie traegt fachlich.
 *
 * ANMERKUNG: Die IDs `see` und `zoll` sind zugleich Board-Status-IDs bzw. Alt-Status-Schluessel aus
 * `LEGACY_STATUS` (index.html:4166), bezeichnen hier aber Transportstufen. Die Doppelbelegung
 * stammt aus dem Original und ist bewusst nicht aufgeloest.
 */
export const SHIP_STAGES: readonly ShipStage[] = [
  { id: "hersteller", label: "Gebucht" },
  { id: "hafen_ab", label: "Hafen CN" },
  { id: "see", label: "See" },
  { id: "hafen_de", label: "Hafen DE" },
  { id: "zoll", label: "Zoll" },
  { id: "absina", label: "ABSINA" },
];

export interface ContainerType {
  id: string;
  label: string;
  /** Ladevolumen in Kubikmetern. */
  vol: number;
}

/**
 * Containergroessen (index.html:4532-4535).
 *
 * ANMERKUNG: Im Original steht direkt ueber dieser Konstante der Kommentar
 * `// Bestell-Status → wie weit auf dem Zeitstrahl (Index der erreichten Stufe)`
 * (index.html:4531). Er gehoert inhaltlich nicht zu `CONTAINER_TYPES`, sondern beschreibt eine
 * Zuordnung, die dort nicht (mehr) steht - vermutlich ein Rest einer entfernten Konstante. Er ist
 * hier bewusst NICHT mit uebernommen, weil er den Leser in die Irre fuehren wuerde; gemeldet statt
 * im Original geaendert.
 *
 * Die Label verwenden das Zoll-Zeichen als gerades Anfuehrungszeichen (`20"`), woertlich wie im
 * Original.
 */
export const CONTAINER_TYPES: readonly ContainerType[] = [
  { id: "20", label: '20" Container', vol: 33 },
  { id: "40", label: '40" Container', vol: 67 },
];
